import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	search: {
		id: 'project-create-importer-upload-flow.common.search-bar.search',
		defaultMessage: 'Search all fields',
		description: 'Placeholder text for search bar',
	},
});
